import React from 'react'
import FormField from '@/components/common/FormField'
import { Button } from '@/components/ui/button'
import { Spinner } from '@/components/ui/spinner'
import { errorTypes } from '@/utility/validation'
import { useFormContext } from 'react-hook-form'
import type { OnboardTabProps } from './onboard.types'

const OnboardBankDetails: React.FC<OnboardTabProps> = ({ isLoading, handleNextStep }) => {
    const methods = useFormContext()
    const { register, formState: { errors } } = methods

    return (
        <>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <FormField
                    {...register('bankName', {
                        ...errorTypes.required('Bank Name'),
                        ...errorTypes.name,
                    })}
                    error={errors.bankName?.message as string}
                    label="Bank Name"
                    placeholder="Enter bank name"
                />
                <FormField
                    {...register('accountNumber', {
                        ...errorTypes.required('Account Number'),
                    })}
                    error={errors.accountNumber?.message as string}
                    label="Account Number"
                    placeholder="Enter account number"
                />
                <FormField
                    {...register('accountHolderName', {
                        ...errorTypes.required('Account Holder Name'),
                        ...errorTypes.name,
                    })}
                    error={errors.accountHolderName?.message as string}
                    label="Account Holder Name"
                    placeholder="Enter account holder name"
                />
                <FormField
                    {...register("ifscCode", { ...errorTypes.required('IFSC/RTGS Code') })}
                    error={errors.ifscCode?.message as string}
                    label="IFSC/RTGS Code"
                    placeholder="Enter ifsc/rtgs code"
                />
                <FormField
                    {...register("branchAddress", { ...errorTypes.required('Branch Address') })}
                    error={errors.branchAddress?.message as string}
                    label="Branch Address"
                    placeholder="Enter branch address"
                    rows={3}
                />
            </div>
            <div className="flex items-center justify-end mt-6">
                <Button
                    type="button"
                    onClick={() => handleNextStep('tab6', ['bankName', 'accountNumber', 'accountHolderName', 'ifscCode', 'branchAddress'])}
                >
                    {isLoading ? <Spinner /> : 'Save and Continue'}
                </Button>
            </div>
        </>
    )
}

export default OnboardBankDetails
